import { Box, Button, Grid, Typography, createStyles, makeStyles } from '@material-ui/core';
import { ReactElement, ReactNode } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ITemplateProps } from './ITemplateProps';
import commonStyleRules from '../styles';
import styleRules from '../Registration/styles';
import styles from '../Login/styles';

interface Props extends ITemplateProps {
  form?: JSX.Element;
  hint?: ReactNode;
  socialNetworks?: ReactNode;
  disableSubmit?: boolean;
  isLoading?: boolean;
}

const PageTemplate = ({
  description,
  disableSubmit,
  form,
  hint,
  isLoading,
  socialNetworks,
  submit,
  submitButtonContent,
  title,
}: Props): ReactElement => {
  const useStyles = makeStyles((theme) =>
    createStyles({ ...commonStyleRules(theme), ...styleRules(theme), ...styles(theme) })
  );
  const {
    bottom,
    buttonContainer,
    submitButton,
    content,
    serviceRules,
    serviceRulesWrapper,
    stepDescription,
    stepTitle,
    typographySecondary,
  } = useStyles();

  const isLoginPage = Boolean(socialNetworks);
  const descriptionColor = isLoginPage ? typographySecondary : stepDescription;
  const buttonContent = isLoading ? <CircularProgress /> : submitButtonContent;

  return (
    <Grid container item direction="column" justifyContent="space-between" wrap="nowrap" className={content}>
      <Grid>
        <Grid>
          <Grid item md={6} xl={6}>
            <Typography variant="h4" className={stepTitle}>
              {title}
            </Typography>
          </Grid>
          <Grid item md={8} xl={8}>
            <Typography className={descriptionColor}>{description}</Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid container item xl={12} className={bottom}>
        {form}
        <Grid container className={buttonContainer}>
          <Button
            variant="contained"
            color="primary"
            onClick={submit}
            className={submitButton}
            disabled={disableSubmit || isLoading}
          >
            {buttonContent}
          </Button>
          {socialNetworks}
          <Box className={serviceRulesWrapper}>
            <Typography className={serviceRules}>{hint}</Typography>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PageTemplate;
